import React from 'react';
import { Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
// Api
import { DELETE_TRANSITION } from 'api/video-merge-job/mutations';
// Types
import { GetTransitions_getTransitions } from 'api/video-merge-job/types/GetTransitions';
// UI
import { errorNotification, successNotification } from 'ui/Notification';
// Styles
import styles from './Actions.module.scss';

interface ActionsProps {
  transition: GetTransitions_getTransitions;
  onEdit: (record: GetTransitions_getTransitions) => void;
  onDelete: () => void;
}

const Actions: React.FC<ActionsProps> = ({ transition, onEdit, onDelete }) => {
  const [deleteTransition, { loading }] = useMutation(DELETE_TRANSITION, {
    onCompleted: () => {
      successNotification('Transition deleted successfully');
      onDelete();
    },
    onError: (error) => {
      errorNotification(error.message);
    },
  });

  const handleDelete = () => {
    deleteTransition({
      variables: {
        id: transition.id,
      },
    });
  };

  const handleEdit = () => {
    onEdit(transition);
  };

  return (
    <div className={styles.actionsContainer}>
      <Button
        type="link"
        icon={<EditOutlined />}
        onClick={handleEdit}
        disabled={loading}
      >
        Edit
      </Button>
      <Popconfirm
        title="Are you sure you want to delete this transition?"
        onConfirm={handleDelete}
        okText="Yes"
        cancelText="No"
      >
        <Button type="link" danger icon={<DeleteOutlined />} disabled={loading}>
          Delete
        </Button>
      </Popconfirm>
    </div>
  );
};

export default Actions;
